<div class="fix-action-dialog">
	<div fxLayout="row" fxLayoutAlign="start">
		<div class="card-title">
			<h2 mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;"><span data-idtest="belongs-dialog-t-0Tf" translate>メールアドレス</span>：{{username}}</h2>
		</div>
	</div>

	<mat-dialog-content #dialog_content [ngSwitch]="type">

		<div *ngSwitchCase="'manage'">
		</div>

		<div *ngSwitchCase="'company'">
			<mat-card *ngIf="company_url" style="background-color:#525355;margin:32px 8px 8px 8px;">
				<mat-card-header>
					<mat-card-title style="color:#fdfdfd;font-size:14px;font-weight:700;"><span data-idtest="belongs-dialog-t-1Qr" translate>企業URL</span></mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<a [href]="company_url" style="color:#fdfdfd;font-size:18px;font-weight:700;">{{company_url}}</a>
				</mat-card-content>
			</mat-card>
			<form #form="ngForm" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" novalidate style="margin:8px;background: #585858;">
				<div fxLayout="column" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
					<mat-card style="margin:8px;">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0;"><span data-idtest="belongs-dialog-t-0Sk" translate>管理選択</span></mat-card-title>
							<span data-idtest="belongs-dialog-t-9Zf" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">
								<mat-form-field class="input-text" style="width: 100%;">
									<mat-label><span data-idtest="belongs-dialog-t-1Nr" translate>管理</span></mat-label>
									<mat-select #manage_select="ngModel" [(ngModel)]="manage" name="manage_select" required>
										<mat-option *ngFor="let manage of manages" [value]="manage">
											{{manage.nickname}}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="manage_select.errors?.['required'];"><span data-idtest="belongs-dialog--8Rv" translate>選択してください</span></mat-error>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<button mat-raised-button (click)="onAddItem(manage)" [disabled]="(form.invalid || isProgress || !manage)" style="background-color:#8e8e8e;width: 110px;">
							<div fxLayout="row" fxLayoutAlign="space-between center">
								<mat-icon fxFlex="30">add_circle</mat-icon>
								<div data-idtest="belongs-dialog-t-6Lk" fxFlex="70" translate>追加</div>
							</div>
						</button>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title data-idtest="belongs-dialog-t-8Ba" style="font-weight:900;font-size:9px;">link</mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #company_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(manage.account)" *ngFor="let manage of selected_manages" [removable]="true" [selectable]="true">
										{{manage.account.content.nickname}}
										<mat-icon matChipRemove *ngIf="delete_enable">cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title data-idtest="belongs-dialog-t-0Jp" style="font-weight:900;font-size:9px;color:crimson">invalid</mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #anomaly_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(user.account)" *ngFor="let user of union([selected_users,selected_studios,selected_trainers,selected_companies])" [removable]="true" [selectable]="true">
										{{user.account.content.nickname}}
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
				</div>
				<belongs-panel style="margin:8px;" #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
			</form>
		</div>

		<div *ngSwitchCase="'studio'">
			<mat-card *ngIf="studio_url" style="background-color:#525355;margin:32px 8px 8px 8px;">
				<mat-card-header>
					<mat-card-title style="color:#fdfdfd;font-size:14px;font-weight:700;"><span data-idtest="belongs-dialog-t-2Hc" translate>スタジオURL</span></mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<a [href]="studio_url" style="color:#fdfdfd;font-size:18px;font-weight:700;">{{studio_url}}</a>
				</mat-card-content>
			</mat-card>
			<form #form="ngForm" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" novalidate style="margin:8px;background: #585858;">
				<div fxLayout="column" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
					<mat-card style="margin:8px;">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0;"><span data-idtest="belongs-dialog-t-3Ft" translate>企業選択</span></mat-card-title>
							<span data-idtest="belongs-dialog-t-9Hh" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">
								<mat-form-field class="input-text" style="width: 100%;">
									<mat-label><span data-idtest="belongs-dialog-t-8Cl" translate>企業</span></mat-label>
									<mat-select #company_select="ngModel" [(ngModel)]="company" name="company_select" required>
										<mat-option *ngFor="let company of companies" [value]="company">
											{{company.account.content.nickname}}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="company_select.errors?.['required'];"><span data-idtest="belongs-dialog-t-7Gb" translate>選択してください</span></mat-error>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<button mat-raised-button (click)="onAddItem(company.account)" [disabled]="(form.invalid || isProgress  || !company)" style="background-color:#8e8e8e;width: 110px;">
							<div fxLayout="row" fxLayoutAlign="space-between center">
								<mat-icon fxFlex="30">add_circle</mat-icon>
								<div data-idtest="belongs-dialog-t-2Cg" fxFlex="70" translate>追加</div>
							</div>
						</button>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title style="font-weight:900;font-size:9px;"><span data-idtest="belongs-dialog-t-0Ib" translate>所属先</span></mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #studio_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(company.account)" *ngFor="let company of selected_companies" [removable]="true" [selectable]="true">
										{{company.account.content.nickname}}
										<mat-icon matChipRemove *ngIf="delete_enable">cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>

					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title style="font-weight:900;font-size:9px;color:crimson"><span data-idtest="belongs-dialog-t-8Bj" translate>所属エラー</span></mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #anomaly_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(user.account)" *ngFor="let user of union([selected_users,selected_studios,selected_trainers])" [removable]="true" [selectable]="true">
										{{user.account.content.nickname}}
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
				</div>
				<belongs-panel style="margin:8px;" #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
			</form>
		</div>

		<div *ngSwitchCase="'trainer'">
			<form #form="ngForm" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" novalidate style="margin:8px;background: #585858;">
				<div fxLayout="column" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
					<mat-card style="margin:8px;">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0;"><span data-idtest="belongs-dialog-t-1Oq" translate>スタジオ選択</span></mat-card-title>
							<span data-idtest="belongs-dialog-t-2Tx" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">
								<mat-form-field class="input-text" style="width: 100%;">
									<mat-label><span data-idtest="belongs-dialog-t-3Dp" translate>スタジオ</span></mat-label>
									<mat-select #studio_select="ngModel" (selectionChange)="onChangeStudio()" [(ngModel)]="studio" name="studio_select" required>
										<mat-option *ngFor="let studio of studios" [value]="studio">
											{{studio.account.content.nickname}}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="studio_select.errors?.['required'];"><span data-idtest="belongs-dialog-t-5Zu" translate>選択してください</span></mat-error>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<button mat-raised-button (click)="onAddItem(studio.account)" [disabled]="(form.invalid || isProgress || !studio)" style="background-color:#8e8e8e;width: 110px;">
							<div fxLayout="row" fxLayoutAlign="space-between center">
								<mat-icon fxFlex="30">add_circle</mat-icon>
								<div data-idtest="belongs-dialog-t-9Sm" fxFlex="70" translate>追加</div>
							</div>
						</button>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title style="font-weight:900;font-size:9px;"><span data-idtest="belongs-dialog-t-1Nt" translate>所属先</span></mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #trainer_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(studio.account)" *ngFor="let studio of selected_studios" [removable]="true" [selectable]="true">
										{{studio.account.content.nickname}}
										<mat-icon matChipRemove *ngIf="delete_enable">cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title style="font-weight:900;font-size:9px;color:crimson"><span data-idtest="belongs-dialog-t-7Ci" translate>所属エラー</span></mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #anomaly_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(user.account)" *ngFor="let user of union([selected_users,selected_trainers,selected_companies])" [removable]="true" [selectable]="true">
										{{user.account.content.nickname}}
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
				</div>
				<belongs-panel style="margin:8px;" #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
			</form>
		</div>

		<div *ngSwitchCase="''">
			<form #form="ngForm" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" novalidate style="margin:8px;background: #585858;">
				<div fxLayout="column" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
					<mat-card style="margin:8px;">
						<mat-card-header>
							<mat-card-title style="font-size: 1.6vh;font-weight: bold;margin-bottom: 0;"><span data-idtest="belongs-dialog-t-5Iy" translate>スタジオ選択</span></mat-card-title>
							<span data-idtest="belongs-dialog-t-2Md" style="font-size: 8px;border: 1px solid #ccc;" translate>必須入力</span>
						</mat-card-header>
						<mat-card-content>
							<div fxlayout="row">
								<mat-form-field class="input-text" style="width: 100%;">
									<mat-label><span data-idtest="belongs-dialog-t-3Ta" translate>スタジオ</span></mat-label>
									<mat-select #studio_select="ngModel" (selectionChange)="onChangeStudio()" [(ngModel)]="studio" name="studio_select" required>
										<mat-option *ngFor="let studio of studios" [value]="studio">
											{{studio.account.content.nickname}}
										</mat-option>
									</mat-select>
									<mat-error *ngIf="studio_select.errors?.['required'];"><span data-idtest="belongs-dialog-t-6Zw" translate>選択してください</span></mat-error>
								</mat-form-field>
							</div>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<button mat-raised-button (click)="onAddItem(studio.account)" [disabled]="(form.invalid || isProgress || !studio)" style="background-color:#8e8e8e;width: 110px;">
							<div fxLayout="row" fxLayoutAlign="space-between center">
								<mat-icon fxFlex="30">add_circle</mat-icon>
								<div data-idtest="belongs-dialog-t-9Lw" fxFlex="70" translate>追加</div>
							</div>
						</button>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title style="font-weight:900;font-size:9px;"><span data-idtest="belongs-dialog-t-3Tg" translate>所属先</span></mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #trainer_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(studio.account)" *ngFor="let studio of selected_studios" [removable]="true" [selectable]="true">
										{{studio.account.content.nickname}}
										<mat-icon matChipRemove *ngIf="delete_enable">cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
					<mat-card style="margin:8px;text-align: center;">
						<mat-card-header>
							<mat-card-title style="font-weight:900;font-size:9px;color:crimson"><span data-idtest="belongs-dialog-t-8Jo" translate>所属エラー</span></mat-card-title>
						</mat-card-header>
						<mat-card-content>
							<mat-form-field>
								<mat-chip-list #anomaly_chip_list aria-label="column">
									<mat-chip (removed)="onRemoveItem(user.account)" *ngFor="let user of union([selected_users,selected_trainers,selected_companies])" [removable]="true" [selectable]="true">
										{{user.account.content.nickname}}
										<mat-icon matChipRemove>cancel</mat-icon>
									</mat-chip>
								</mat-chip-list>
							</mat-form-field>
						</mat-card-content>
					</mat-card>
				</div>
				<belongs-panel style="margin:8px;" #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
			</form>
		</div>

	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
		<button (click)="onAccept()" color="primary" mat-raised-button id="mat-ok-button"><span data-idtest="belongs-dialog-t-0Tt" translate>閉じる</span></button>
	</mat-dialog-actions>
</div>
